import { requestGet } from '@/common/request';

export interface guideParams {
  key: string;
}

export interface guideRes {
  ret?: string;
  msg?: string;
  code?: string;
}

/**
 * 用户引导
 * 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=385162767
 * 引导key：
 *  globalGuide：营销中心全局引导
 *  homeNewUser:是否完成首页新人引导
 *  actManageList:是否完成活动管理模块列表部分新人引导
 *  actManageDetail:是否完成活动管理模块详情部分新人引导
 *  openSec：首页融合秒杀智慧营销气泡提醒
 *  homeSearch：工作台搜索功能
 *  userFeedback：用户反馈
 *  kpl:  跨品类营销
 *  mcImport：消息中心入口是否完成用户引导
 *  mcMyFollow：消息中心内部【我的关注】是否完成用户引导
 */
export const USER_GUIDE_KEY = {
  globalGuide: {
    key: 'globalGuide',
    name: '营销中心全局引导',
  },
  homeNewUser: {
    key: 'homeNewUser',
    name: '是否完成首页新人引导',
  },
  actManageList: {
    key: 'actManageList',
    name: '是否完成活动管理模块列表部分新人引导',
  },
  actManageDetail: {
    key: 'actManageDetail',
    name: '是否完成活动管理模块详情部分新人引导',
  },
  openSec: {
    key: 'openSec',
    name: '首页融合秒杀智慧营销气泡提醒',
  },
  homeSearch: {
    key: 'homeSearch',
    name: '工作台搜索功能',
  },
  userFeedback: {
    key: 'userFeedback',
    name: '用户反馈',
  },
  kpl: {
    key: 'kpl',
    name: '跨品类营销',
  },
  mcImport: {
    key: 'mcImport',
    name: '消息中心入口是否完成用户引导',
  },
  mcMyFollow: {
    key: 'mcMyFollow',
    name: '消息中心内部【我的关注】是否完成用户引导',
  },
  goodsMonitoring: {
    key: 'goodsMonitoring',
    name: '货品监控引导',
  },
};

export async function guide(params: guideParams): Promise<guideRes> {
  return await requestGet('/user/guide', params);
}
